import {
  includeStringValue
 } from "../tools/string-tools";
/**
 * Validadores para las guardias de empresa
 */
export class EmpresaGuardValidators {
  private constructor() {}

  /**
   * Valida si la url es de WMS
   * @param url - string - Url a validar
   * @returns boolean - true si la url es de WMS, false en caso contrario
   */
  static validarWMS(url: string): boolean {
    return includeStringValue(url, '/wms');
  }

  static validarSuministros(url: string): boolean {
    return includeStringValue(url, '/suministros');
  }

  /**
   * Valida si la url es de Punto de Venta
   * @param url - string - Url a validar
   * @returns boolean - true si la url es de Punto de Venta, false en caso contrario
   */
  static validarPuntoVenta(url: string): boolean {
    return includeStringValue(url, '/punto-venta');
  }
}
